class QuantitySelector {
    constructor() {
        this.max = 0
        this.current = 0
        this.elsButtons = []
        this._init()
    }
    _init() {
        this.elPrice = document.querySelector('[data-variants-price]')
        this.els = document.querySelectorAll('[data-quantity-selector]')
        this.els.forEach(el => this.initElement(el))
    }
    initElement(el) {
        this.max = el.dataset.hasOwnProperty('quantitySelectorMax') ? Number.parseInt(el.dataset.quantitySelectorMax) : -1
        el.querySelectorAll('[data-quantity-selector-item]').forEach(item => this.initButton(item))
    }
    initButton(el) {
        this.elsButtons.push(el)

        const maxStock = el.dataset.hasOwnProperty('quantitySelectorItemMax') ? Number.parseInt(el.dataset.quantitySelectorItemMax) : -1
        const price = el.dataset.hasOwnProperty('quantitySelectorItemPrice') ? Number.parseFloat(el.dataset.quantitySelectorItemPrice) : 0.0
        const elButtonSubtract = el.querySelector('[data-quantity-selector-item-subtract]')
        const elButtonAdd = el.querySelector('[data-quantity-selector-item-add]')
        const elInput = el.querySelector('input')

        elButtonSubtract.addEventListener('click', () => {
            const value = Number.parseInt(elInput.value)
            if (this.current >= 0) {
                elInput.value = Math.max(0, value - 1)
                //this.current = Math.max(0, this.current - 1)

                this.updateCurrent()
                if (this.elPrice && price > 0) {

                    this.updatePrice()
                }
            }
        })
        elButtonAdd.addEventListener('click', () => {
            const value = Number.parseInt(elInput.value)
            const max = maxStock != -1 ? maxStock : this.max
            if (this.max == -1) {
                elInput.value = Math.max(value + 1, 0)
                this.updateCurrent()

            } else if (this.current < this.max) {
                elInput.value = Math.min(value + 1, max)
                this.updateCurrent()
            }
            if (this.elPrice && price > 0) {
                this.updatePrice()
            }
        })
    }
    updateCurrent() {
        const total = Array.from(this.elsButtons).reduce((accumulator, el) => {
            const elInput = el.querySelector('input')
            const quantity = Number.parseInt(elInput.value || 0)
            return accumulator + quantity
        }, 0)
        this.current = total
    }
    updatePrice() {
        const total = Array.from(this.elsButtons).reduce((accumulator, el) => {
            if (el.dataset.hasOwnProperty('quantitySelectorItemPrice')) {
                const priceUnity = Number.parseFloat(el.dataset.quantitySelectorItemPrice)
                const elInput = el.querySelector('input')
                const quantity = Number.parseInt(elInput.value || 0)
                return accumulator + (priceUnity * quantity)
            }
            return accumulator
        }, 0.0)
        this.elPrice.innerText = this.getFormatted(total)
    }
    getFormatted(value) {
		let s = parseFloat(value).toFixed(2)
		s = s.split('.')
		let formatted = s[0] + "," + s[1]
		return formatted
	}
}

export default QuantitySelector